import { BoxTitles } from "@boxes/BoxTitles";
import classnames from "classnames/bind";
import { memo, useState } from "react";
import { Handle } from "reactflow";

import style from "@styles/pages/flow/boxes/Box.module.scss";

const css = classnames.bind(style);

export default memo(({ data, selected, isConnectable }) => {
  const [collapse, setCollapse] = useState(false);

  return (
    <div
      className={css({ selected: selected, nodrag: true })}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={css({ inner: true, trigger: true })}>
        <div className={style.header}>
          <div className="d-flex align-center justify-between flex-1">
            <div className="d-flex align-center">
              <div className={style.icon}>
                <i className="fal fa-bolt" />
              </div>
              <div className="d-flex flex-column">
                <p className={style.title}>{BoxTitles.Trigger}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Handle
        type="source"
        position="right"
        className={style.handleSource}
        isConnectable={isConnectable}
      />
    </div>
  );
});
